import React, { useState, useEffect } from "react";
import { CssBaseline, Grid } from "@material-ui/core";

import { getData } from "./api";

import Header from "./components/Header/Header";
import List from "./components/List/List";
import Map from "./components/Map/Map";
import PlaceDetails from "./components/PlaceDetails/PlaceDetails";

const App = () => {
  const [places, setPlaces] = useState([]);
  const [filteredPlaces, setFilteredPlaces] = useState([]);
  const [childClicked, setChildClicked] = useState(null);

  const [coordinates, setCoordinates] = useState({});
  const [bounds, setBounds] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState('restaurants');
  const [rating, setRating] = useState('');

  // Grabs current location
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(({ coords: { latitude, longitude } }) => {
      setCoordinates({ lat: latitude, lng: longitude });
    });
  }, []);

  // Get data call
  useEffect(() => {
    if(bounds.sw && bounds.ne) {
    setIsLoading(true);

	  getData(type,bounds.sw, bounds.ne)
	  	.then ((data) => {
			  // console.log(data);
			  setPlaces(data?.filter((place) => place.name && place.num_reviews > 0));
        setFilteredPlaces([]);
        setIsLoading(false);
		  })
    }
  },[bounds,type]);

  // Filtered Ratings
  useEffect(() => {
    const filteredPlaces = places.filter((place) => place.rating > rating)
    setFilteredPlaces(filteredPlaces);
  }, [rating])

  return (
    <>
      <CssBaseline />
      <Header setCoordinates = {setCoordinates} />
      <Grid container spacing={3} style={{ width: "100%" }}>
        <Grid item xs={12} md={4}>
          <List places = { filteredPlaces.length ? filteredPlaces : places } childClicked = {childClicked} isLoading={isLoading} type={type} setType={setType} rating={rating} setRating={setRating}/>
        </Grid>
        <Grid item xs={12} md={8} style = {{display : 'flex', justifyContent:'center', alignItems: 'center'}}>
          <Map setCoordinates = {setCoordinates} setBounds = {setBounds} coordinates={coordinates} places = {filteredPlaces.length ? filteredPlaces : places} setChildClicked = {setChildClicked} />
        </Grid>
      </Grid>
    </>
  );
};

export default App;
